import { TFunction } from 'react-i18next';

const transactionTypeToChipTitleTransformer = (t: TFunction, transactionType?: number) => {
  if (transactionType === 1) {
    return t('Filters.Debit');
  } else if (transactionType === 2) {
    return t('Filters.Credit');
  }
};

export { transactionTypeToChipTitleTransformer };
